import styled from 'styled-components'
import { LIGHTGRAY } from '../../styles/colors.style'
import { isMobile } from '../../services/breakpoints.service'
import { breakpoints } from '../../constants'

export const LineTitleWrapper = styled.span`
	align-items: center;
	display: flex;
	flex-direction: row;
	font-size: 2rem;
	margin-top: 9px;
	width: 100%;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		font-size: 1.3rem;
	}
`

export const LineTitleLeft = styled.span`
	background: ${LIGHTGRAY};
	flex-grow: 1;
	height: 1px;
	margin-right: 7px;
`

export const LineTitleRight = styled.span`
	background: ${LIGHTGRAY};
	flex-grow: 1;
	height: 1px;
	margin-left: 7px;
`

export const StyledContainer = styled.div`
	cursor: pointer;
	width: ${isMobile() ? 30 : 15}rem;

	& > img {
		max-width: 100%;
	}

	.name {
		font-size: ${isMobile() ? 2.4 : 1.4}rem;
	}

	.points {
		font-size: ${isMobile() ? 3.3 : 2.3}rem;
		font-weight: bold;
	}

	.no-margin {
		margin: 0;
	}

	.startingAt {
		font-size: ${isMobile() ? 2.5 : 1.5}rem;
	}
`
